import * as React from 'react'

import getConfig from 'next/config'

import { AuthProvider, Routes, Types } from '@grandvisionhq/auth'

type AuthConfig = React.ComponentProps<typeof AuthProvider>['settings']

const { publicRuntimeConfig } = getConfig()
const apiUrl = publicRuntimeConfig.grandvision.apiUrl ?? ''
const {
  auth0Domain,
  auth0CustomDomain,
  auth0ClientId,
  putPrescriptionTokensOnCart,
  disableAddressEditing,
} = publicRuntimeConfig.grandvision.myAccount ?? {}

const routes: Routes = {
  createAccount: 'create',
  login: 'login',
  logout: 'logout',
  orders: 'orders',
  signup: 'signup',
  cccSubscriptions: 'ccc',
  profile: 'profile',
  settings: 'settings',
  appointments: 'appointments',
  resetPassword: 'reset-password',
  linkExpired: 'link-expired',
  setPassword: 'set-password',
  unlinkOrder: 'unlink-order',
  changePassword: 'change-password',
  verify: 'verify',
  wishlist: 'wishlist',
}

const optIns: Types.OptInItem[] = [
  {
    titleKey: 'account.optIn.marketingEmails',
    tooltipKey: 'account.optIn.marketingEmails.tooltip',
    value: 'marketingEmails',
    isInSignup: true,
  },
  {
    titleKey: 'account.optIn.generalCommunication',
    tooltipKey: 'account.optIn.generalCommunication.tooltip',
    value: 'generalCommunication',
  },
]

const supportFeaturesLinks: Types.SupportFeatureLink[] = [
  {
    label: 'account.menu.appointments',
    url: routes.appointments,
  },
  {
    label: 'account.menu.orders',
    url: routes.orders,
  },
  {
    label: 'account.menu.subscriptions',
    url: routes.cccSubscriptions,
  },
  {
    label: 'account.menu.settings',
    url: routes.settings,
  },
]

export const getAuthConfig = (): AuthConfig => ({
  routes,
  optIns,
  apiUrl,
  putPrescriptionTokensOnCart,
  disableAddressEditing,
  clientId: auth0ClientId,
  customDomain: auth0CustomDomain,
  domain: auth0Domain,
  basePath: 'my-account',
  checkoutRoute: '/checkout',
  supportFeaturesLinks,
})
